/**
 * Node.js global polyfills for browser — required by PDFKit and amazon-cognito-identity-js.
 * Must be imported before any code that depends on `Buffer` or `process`.
 */
import { Buffer } from "buffer";
import process from "process";

globalThis.Buffer = Buffer;
globalThis.process = process;

// The process polyfill uses setTimeout for nextTick (~4ms per tick). PDFKit's stream
// writes call nextTick on every chunk, making PDF generation extremely slow.
// queueMicrotask gives near-zero overhead. This blocks the thread until the microtask
// chain completes, but PDF generation runs in a Web Worker so that's fine.
process.nextTick = function (fn: (...args: unknown[]) => void, ...args: unknown[]) {
  if (args.length === 0) {
    queueMicrotask(fn);
  } else {
    queueMicrotask(() => fn(...args));
  }
} as typeof process.nextTick;
